export const TIMEZONE_MODE = {
  participantLocal: 'participant_local',
  siteLocal: 'site_local',
  gmt: 'gmt',
}

export const TIMEZONE_OPTIONS = [
  { key: TIMEZONE_MODE.participantLocal, text: 'Participant local time' },
  { key: TIMEZONE_MODE.siteLocal, text: 'Site local time' },
  { key: TIMEZONE_MODE.gmt, text: 'GMT' },
]
